import request from "@/utils/request.js"

export function getList(parm){
    return request.get("/baogongzhangdan",{
        params:parm
    })
}

export function addBGzhangdan(parm){
    return request.post("/baogongzhangdan",{
        data:parm
    })
}
export function updateBGzhangdan(parm){
    return request.put("/baogongzhangdan",{
        data:parm
    })
}
export function deleteBGzhangdan(parm){
    return request.delete("/baogongzhangdan",{
        params:parm
    })
}
export function exportall(parm){
    return request.get("/baogongzhangdan/export",{
        params:parm
    })
}